import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-common-csv',
  templateUrl: './common-csv.component.html',
  styleUrls: ['./common-csv.component.css']
})
export class CommonCsvComponent {
  @Input() data: any[] = [];
  @Input() fileName: string = ''; 
  @Input() columnsToExport: string[] = []; 

  ngOnChanges() {
    // console.log('Columns to Export:', this.columnsToExport);
  }

  exportToCsv(): void {
    if (!this.data || this.data.length === 0) {
      console.error('No data available for CSV export.');
      return;
    }

    // Determine columns to use
    const columnsToUse = this.columnsToExport.length > 0 
      ? this.columnsToExport 
      : Object.keys(this.data[0]);

    // Generate CSV headers
    const headers = columnsToUse.join(',');

    // Generate CSV rows
    const rows = this.data.map(row => {
      return columnsToUse.map(column => {
        const cellValue = row[column] !== undefined ? row[column] : '';
        return `"${cellValue}"`; // Wrap each cell value in quotes
      }).join(',');
    });

    // Combine headers and rows
    const csvContent = [headers, ...rows].join('\n');

    // Create a Blob and download the file
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `${this.fileName}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
